import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-slick';
// eslint-disable-next-line import/no-extraneous-dependencies
import { Box } from '@mui/material';
import CardDetails from './cardDetails';
import { API_LOAD_COUNT } from '../../constants/app-constants';
import { getCradPreviewLength } from '../../utils/srp.util';
import ListingShimmer from '../../components/srp/Listing/listingShimmer';
import { SlickCaroselRootElement } from './style';
import ContentShimmer from '../../components/srp/Listing/contentShimmer';

const CardCarousel = ({
  partners, handleLoadMore, loading, profile, localImg, view, pagination, handleViewMore, outsideClass,
  hideSliderButtons, dataWatLoc, dataWatVal, isContentShimmer, cardDescClass, getLink, isTitleTranslate,
}) => {
  const [activeStep, setActiveStep] = useState(0);
  const sliderRef = useRef();
  const { total_count: totalCount, next_page: nextPage } = pagination || {};

  useEffect(() => {
    if (loading && !(partners && partners.length)) {
      setActiveStep(0);
    }
    if (!loading && partners?.length && activeStep === 0) {
      sliderRef.current.slickGoTo(0);
    }
  }, [loading, partners, activeStep]);

  const loadMore = () => {
    if (activeStep + getCradPreviewLength() >= partners.length - (API_LOAD_COUNT + getCradPreviewLength()) && !loading && nextPage) {
      handleLoadMore();
    }
  };

  const isNextDisabled = () => partners?.length <= getCradPreviewLength() || activeStep === partners?.length - getCradPreviewLength()
    || totalCount - getCradPreviewLength() <= Math.ceil(activeStep);

  const handleNext = () => {
    if (isNextDisabled()) {
      return;
    }
    loadMore();
    const slidesToScroll = activeStep + getCradPreviewLength();
    sliderRef.current.slickGoTo(slidesToScroll);
    setActiveStep(slidesToScroll);
  };

  const handleBack = () => {
    if (activeStep === 0) {
      return;
    }
    const slidesToScroll = activeStep - getCradPreviewLength();
    sliderRef.current.slickGoTo(slidesToScroll);
    setActiveStep(slidesToScroll);
  };

  const afterSlideChange = (idx) => {
    loadMore();
    setActiveStep(idx);
  };

  const isSliderButtonVisible = () => {
    if (hideSliderButtons) {
      return !!(partners?.length && partners?.length > getCradPreviewLength());
    }
    return !!partners?.length;
  };

  return (
    <SlickCaroselRootElement>
      {isSliderButtonVisible() && (
        <Box
          className="prev-button"
          onClick={handleBack}
          disabled={activeStep === 0}
        >
          Prev
        </Box>
      )}
      {isSliderButtonVisible() && (
        <Box
          className="next-button"
          onClick={handleNext}
          disabled={isNextDisabled()}
        >
          Next
        </Box>
      )}
      <Slider
        ref={sliderRef}
        dots={false}
        infinite={false}
        arrows={false}
        slidesToShow={getCradPreviewLength() + 0.12}
        slidesToScroll={getCradPreviewLength()}
        afterChange={afterSlideChange}
      >
        {!!partners?.length && partners?.map((slice) => (
          <CardDetails
            key={slice.id}
            displayName={profile ? slice?.title : slice?.display_name}
            headline={profile ? slice?.customer_challenge : slice?.headline}
            logo={slice?.logo_url}
            outsideClass={outsideClass}
            cardDescClass={cardDescClass}
            link={getLink}
            localImg={localImg}
            eyebrow={slice?.eyebrow}
            view={view}
            handleViewMore={() => handleViewMore(slice)}
            dataWatLoc={dataWatLoc}
            dataWatVal={dataWatVal}
            isTitleTranslate={isTitleTranslate}
          />
        ))}
        {loading && [...Array(getCradPreviewLength()).keys()].map((idx) => (isContentShimmer ? <ContentShimmer key={idx} img={!profile} /> : <ListingShimmer key={idx} img={!profile} />))}
      </Slider>
    </SlickCaroselRootElement>
  );
};

CardCarousel.propTypes = {
  partners: PropTypes.arrayOf(PropTypes.shape({})),
  handleLoadMore: PropTypes.func,
  loading: PropTypes.bool,
  profile: PropTypes.bool,
  localImg: PropTypes.bool,
  view: PropTypes.bool,
  pagination: PropTypes.shape({}),
  handleViewMore: PropTypes.func,
  outsideClass: PropTypes.string,
  hideSliderButtons: PropTypes.bool,
  dataWatLoc: PropTypes.string,
  dataWatVal: PropTypes.string,
  isContentShimmer: PropTypes.bool,
  cardDescClass: PropTypes.string,
  getLink: PropTypes.func,
  isTitleTranslate: PropTypes.bool,
};
CardCarousel.defaultProps = {
  partners: [],
  handleLoadMore: () => {},
  loading: false,
  profile: false,
  localImg: false,
  view: false,
  pagination: {},
  handleViewMore: () => {},
  outsideClass: '',
  hideSliderButtons: false,
  dataWatLoc: '',
  dataWatVal: '',
  isContentShimmer: false,
  cardDescClass: '',
  getLink: () => {},
  isTitleTranslate: true,
};

export default CardCarousel;
